<template>
    <rkm-form-group class="p-0">
        <template
            v-if="label || items.length > 0"
            slot="label"
        >
            <rkm-row>
                <rkm-col align-self="end" cols="6">
                    {{ label + (!readonly && validations && validations.required ? ' *' : '') }}
                </rkm-col>

                <rkm-col class="text-right" cols="6">
                    <rkm-button
                        v-if="items.length > 0"
                        @click.stop="visible = !visible"
                    >
                        {{ buttonLabel ? buttonLabel : `${items.length} registro(s)` }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </template>

        <template v-if="readonly">
            <rkm-list
                :items="items"
                hide-filters
                hide-pagination
            >
                 <template v-slot="{ item }">
                    <slot name="row" v-bind:item="item" />
                    <slot />
                </template>
            </rkm-list>
        </template>

        <template v-else>
            <rkm-collapse
                v-if="items.length > 0"
                :visible="visible"
                class="mb-1"
            >
                <rkm-list-group>
                    <rkm-list-group-item
                        v-for="(item, i) in items"
                        v-bind:key="i"
                    >
                        <slot name="row" v-bind:item="item" />
                        <slot />
                    </rkm-list-group-item>
                </rkm-list-group>
            </rkm-collapse>

            <rkm-form-textarea
                :name="name || label"
                :validations="validations"
                :value="value"
                @input="$emit('input', $event)"
                rows="4"
            />
        </template>
    </rkm-form-group>
</template>

<script>
export default {
    created() {

        this.visible = this.startVisible
    },
    data: () => ({
        visible: false,
    }),
    props: {
        buttonLabel: { type: String, default: '' },
        items: { type: Array, default: () => [] },
        label: { type: String, default: '' },
        name: { type: String },
        validations: { type: Object },
        value: { type: [Number, String], default: '' },
        readonly: { type: Boolean,  },
        startVisible: { type: Boolean, default: false }
    },
}
</script>